import { SelectHTMLAttributes, forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/utils/cn';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  hint?: string;
  wrapperClassName?: string;
  iconClassName?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, wrapperClassName, iconClassName, label, error, hint, children, ...props }, ref) => {
    return (
      <div className={cn('w-full', wrapperClassName)}>
        {label && <label className="form-label">{label}</label>}
        <div className="select-shell">
          <select
            ref={ref}
            className={cn(
              'form-control form-select min-h-11 pr-12',
              error && 'border-red-500 focus:border-red-500 focus:ring-red-500/15',
              className
            )}
            {...props}
          >
            {children}
          </select>
          <span className={cn('select-icon', iconClassName)}>
            <ChevronDown className="h-4 w-4" />
          </span>
        </div>
        {error ? <p className="mt-1.5 text-sm font-medium text-red-600">{error}</p> : null}
        {!error && hint ? <p className="mt-1.5 text-xs font-medium text-slate-500">{hint}</p> : null}
      </div>
    );
  }
);

Select.displayName = 'Select';
